// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SensorListPagingResultModel from '../../model/sensor-list-paging-result-model';
import SensorListPagingResultDTO from '../dto/sensor-list-paging-result-dto';
import dtoSchema from '../schemas/sensor-list-paging-result-schema';
import SensorListModel from '../../model/sensor-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class SensorListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SensorListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => SensorListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: SensorListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<SensorListPagingResultDTO>): SensorListPagingResultModel;
  static toModel(dto: DeepPartial<SensorListPagingResultDTO> | undefined | null): SensorListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<SensorListPagingResultDTO> | undefined | null): SensorListPagingResultModel | undefined {
    return dto ? new SensorListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SensorListPagingResultModel> | SensorListPagingResultModel): SensorListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as SensorListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SensorListPagingResultModel, can not map to SensorListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
